import Sortable from 'sortablejs';
import { onBeforeUnmount, onMounted } from 'vue';
import { registerManager, unregisterManager } from './sortableRegistry';

export interface SortableManagerApi {
  select: (el: HTMLElement) => void;
  deselect: (el: HTMLElement) => void;
  deselectAll: () => void;
  getSortable: () => Sortable | null;
}

export const useSortableManager = (sortableInstance: Sortable): SortableManagerApi => {
  const select = (el: HTMLElement) => {
    Sortable.utils.select(el);
  };

  const deselect = (el: HTMLElement) => {
    Sortable.utils.deselect(el);
  };

  const deselectAll = () => {
    const selectedElements = document.querySelectorAll(`.${sortableInstance.options.selectedClass}`);
    selectedElements.forEach(el => deselect(el as HTMLElement));
  };

  onMounted(() => {
    registerManager(api);
  });

  onBeforeUnmount(() => {
    sortableInstance?.destroy();
    unregisterManager(api);
  });

  const api: SortableManagerApi = {
    select,
    deselect,
    deselectAll,
    getSortable: () => sortableInstance,
  };
  return api;
};
